import { Component, ViewChild, OnDestroy, Inject, HostListener, AfterViewInit, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatSidenav } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';
import { AgencyService } from './common-theme/api/agency.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieHeightChangeService } from './common-theme/utils/cookie/cookie-height-change.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnDestroy, AfterViewInit {
  @ViewChild('sideNav') sideNav: MatSidenav;
  subscription: Subscription;
  @ViewChild('page') page: ElementRef;
  @ViewChild('navList') navList: ElementRef;

  constructor(
    public agencyService: AgencyService,
    router: Router,
    private translate: TranslateService,
    @Inject('WINDOW') private window: any,
    @Inject(DOCUMENT) private document: any,
    private cookieHeightChangeService: CookieHeightChangeService
  ) {
    router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);

        if (!tree.fragment) {
          if (this.window) {
            this.window.scrollTo(0, 0);
          }
        }
      }
    });

    this.translate.setDefaultLang('ro');
    this.translate.use('ro');
  }

  ngAfterViewInit(): void {
    this.cookieHeightChangeService.emitter.subscribe(
      height => {
        this.page.nativeElement.style.marginTop = height + 'px';

        if (this.navList)
          this.navList.nativeElement.style.marginTop = height + 'px';
      }
    );
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.closeMenuOnDesktop();
  }

  closeMenuOnDesktop(): void {
    if (this.window) {
      if (this.window.innerWidth > 960 && this.sideNav.opened) {
        this.sideNav.close();
        this.document.body.classList.remove('no-scroll');
      }
    }
  }

  toggleSidenav(): void {
    this.sideNav.toggle();

    if (this.sideNav.opened) {
      this.document.body.classList.add('no-scroll');
    } else {
      this.document.body.classList.remove('no-scroll');
    }
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts